import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const PAGE_SIZE = 10;

const _css = `
  .stu-wrap { display: grid; grid-template-columns: 420px 1fr; gap: 22px; align-items: flex-start; }
  .stu-panel { background: #fff; border-radius: 16px; border: 2px solid rgba(247,147,30,0.2); box-shadow: 0 4px 16px rgba(0,0,0,0.07); overflow: hidden; }
  .stu-panel-header { padding: 20px 22px 16px; border-bottom: 2px solid rgba(247,147,30,0.1); display: flex; align-items: center; justify-content: space-between; gap: 12px; }
  .stu-panel-title { display: flex; align-items: center; gap: 10px; }
  .stu-panel-icon { width: 38px; height: 38px; border-radius: 10px; background: rgba(247,147,30,0.12); display: flex; align-items: center; justify-content: center; color: rgb(180,100,5); flex-shrink: 0; }
  .stu-panel-icon svg { display: block; }
  .stu-panel-title h2 { font-size: 16px; font-weight: 800; color: rgb(60,40,10); margin: 0; }
  .stu-panel-title p { font-size: 12px; color: rgb(140,100,55); margin: 2px 0 0; }
  .stu-count-badge { background: rgba(247,147,30,0.12); color: rgb(156,85,4); font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 20px; white-space: nowrap; }
  .stu-search-wrap { padding: 14px 22px 10px; }
  .stu-search-box { display: flex; align-items: center; gap: 8px; background: #faf6f0; border: 1.5px solid rgba(247,147,30,0.25); border-radius: 9px; padding: 8px 12px; transition: border-color .2s, box-shadow .2s; }
  .stu-search-box:focus-within { border-color: rgb(247,147,30); box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff; }
  .stu-search-box input { border: none; background: none; outline: none; font-size: 13px; color: rgb(40,25,5); width: 100%; font-family: inherit; }
  .stu-search-box input::placeholder { color: rgb(180,150,110); }
  .stu-table { width: 100%; border-collapse: collapse; font-size: 13px; }
  .stu-table thead tr { background: rgb(247,147,30); }
  .stu-table thead th { padding: 10px 16px; font-size: 11px; font-weight: 700; text-align: left; color: #fff; white-space: nowrap; }
  .stu-table tbody tr { border-bottom: 1px solid rgba(247,147,30,0.08); cursor: pointer; transition: background .15s; }
  .stu-table tbody tr:last-child { border-bottom: none; }
  .stu-table tbody tr:hover { background: rgba(247,147,30,0.06); }
  .stu-table tbody tr.stu-selected { background: rgba(247,147,30,0.1); border-left: 3px solid rgb(247,147,30); }
  .stu-table tbody td { padding: 11px 16px; color: rgb(60,40,10); }
  .stu-table tbody td:first-child { font-weight: 600; }
  .stu-table tbody td.stu-mother { color: rgb(100,70,30); }
  .stu-pagination { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-top: 1px solid rgba(247,147,30,0.1); }
  .stu-page-info { font-size: 12px; color: rgb(140,100,55); }
  .stu-page-btns { display: flex; gap: 4px; align-items: center; }
  .stu-page-btn { width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border-radius: 7px; border: 1.5px solid rgba(247,147,30,0.25); background: none; font-size: 12px; font-weight: 600; color: rgb(140,100,55); cursor: pointer; transition: all .15s; font-family: inherit; }
  .stu-page-btn:hover:not(:disabled) { border-color: rgb(247,147,30); color: rgb(100,55,0); background: rgba(247,147,30,0.06); }
  .stu-page-btn.stu-page-active { background: rgb(247,147,30); color: #fff; border-color: rgb(247,147,30); }
  .stu-page-btn:disabled { opacity: 0.35; cursor: default; }
  .stu-page-sep { font-size: 13px; color: rgb(180,140,90); padding: 0 2px; }
  .stu-detail { background: #fff; border-radius: 16px; border: 2px solid rgba(247,147,30,0.2); box-shadow: 0 4px 16px rgba(0,0,0,0.07); overflow: hidden; position: sticky; top: 84px; }
  .stu-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 56px 24px; gap: 14px; text-align: center; }
  .stu-empty-title { font-size: 15px; font-weight: 700; color: rgb(120,90,50); margin: 0; }
  .stu-empty-sub { font-size: 13px; color: rgb(160,120,70); margin: 0; }
  .stu-detail-header { padding: 22px 24px 18px; border-bottom: 2px solid rgba(247,147,30,0.1); display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
  .stu-detail-name { font-size: 18px; font-weight: 800; color: rgb(60,40,10); margin: 0; }
  .stu-detail-sub { font-size: 13px; color: rgb(140,100,55); margin: 3px 0 0; }
  .stu-edit-btn { display: inline-flex; align-items: center; gap: 5px; background: rgb(247,147,30); color: #fff; border: none; border-radius: 8px; padding: 7px 14px; font-size: 12px; font-weight: 700; cursor: pointer; text-decoration: none; white-space: nowrap; transition: background .2s; flex-shrink: 0; }
  .stu-edit-btn:hover { background: rgb(210,120,10); color: #fff; }
  .stu-chips { display: flex; flex-wrap: wrap; gap: 8px; padding: 14px 24px; border-bottom: 2px solid rgba(247,147,30,0.1); }
  .stu-chip { display: flex; align-items: center; gap: 6px; background: #faf6f0; border: 1.5px solid rgba(247,147,30,0.2); border-radius: 8px; padding: 6px 11px; font-size: 12px; color: rgb(80,55,20); }
  .stu-chip svg { color: rgb(180,100,5); flex-shrink: 0; display: block; }
  .stu-chip strong { font-weight: 700; color: rgb(40,25,5); }
  .stu-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; padding: 14px 24px; border-bottom: 2px solid rgba(247,147,30,0.1); }
  .stu-stat { background: rgba(247,147,30,0.07); border-radius: 10px; padding: 12px 14px; }
  .stu-stat-value { font-size: 22px; font-weight: 800; color: rgb(60,40,10); }
  .stu-stat-label { font-size: 11px; color: rgb(140,100,55); margin-top: 2px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px; }
  .stu-lessons { padding: 14px 24px 20px; max-height: 340px; overflow-y: auto; }
  .stu-lessons::-webkit-scrollbar { width: 5px; }
  .stu-lessons::-webkit-scrollbar-thumb { background: rgba(247,147,30,0.3); border-radius: 10px; }
  .stu-month-group { margin-bottom: 14px; }
  .stu-month-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; color: rgb(140,100,55); margin-bottom: 7px; display: flex; align-items: center; gap: 6px; }
  .stu-month-label::after { content: ''; flex: 1; height: 1px; background: rgba(247,147,30,0.15); }
  .stu-month-inactive .stu-month-label { color: rgb(200,170,130); }
  .stu-month-inactive .stu-month-label::after { background: rgba(247,147,30,0.08); }
  .stu-lesson-row { display: flex; align-items: center; gap: 10px; padding: 8px 10px; background: #faf6f0; border-radius: 8px; margin-bottom: 5px; font-size: 12px; color: rgb(60,40,10); }
  .stu-lesson-dot { width: 7px; height: 7px; border-radius: 50%; background: rgb(247,147,30); flex-shrink: 0; }
  .stu-lesson-date { font-weight: 700; color: rgb(100,65,10); min-width: 70px; }
  .stu-lesson-dur { background: rgba(247,147,30,0.15); color: rgb(156,85,4); font-size: 11px; font-weight: 700; padding: 2px 7px; border-radius: 5px; white-space: nowrap; }
  .stu-lesson-subject { color: rgb(80,55,20); flex: 1; }
  .stu-no-classes { font-size: 12px; color: rgb(180,140,90); font-style: italic; padding: 3px 10px 5px; }
  @media (max-width: 900px) { .stu-wrap { grid-template-columns: 1fr; } .stu-detail { position: static; } }
  @media (max-width: 600px) { .stu-wrap { gap: 16px; } }
`;

function Students() {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentLessons, setStudentLessons] = useState([]);
  const [inactiveMonths, setInactiveMonths] = useState([]);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);

  const studentsPath = '/students/get';
  const studentPath = '/students/lessons/';

  useEffect(() => {
    fetch(studentsPath)
      .then((r) => r.json())
      .then((data) => setStudents(data))
      .catch(console.log);
  }, []);

  function selectStudent(student) {
    setSelectedStudent(student);
    setStudentLessons([]);
    setInactiveMonths([...months]);
    fetch(`${studentPath}${student.id}`)
      .then((r) => r.json())
      .then((data) => {
        data.sort((a, b) => months.indexOf(a.month) >= months.indexOf(b.month) ? 1 : -1);
        setStudentLessons(data);
        let remaining = [...months];
        data.forEach((lesson) => {
          const i = remaining.indexOf(lesson.month);
          if (i > -1) remaining.splice(i, 1);
        });
        setInactiveMonths(remaining);
      })
      .catch(console.log);
  }

  const sorted = [...students].sort((a, b) => (a.name > b.name ? 1 : -1));
  const filtered = sorted.filter((s) =>
    s.name.toLowerCase().includes(query.toLowerCase()) ||
    s.mother.toLowerCase().includes(query.toLowerCase())
  );
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageStart = (page - 1) * PAGE_SIZE;
  const pageRows = filtered.slice(pageStart, pageStart + PAGE_SIZE);

  function handleSearch(e) {
    setQuery(e.target.value);
    setPage(1);
  }

  // Pagination buttons: show first, last, current ±1, with ellipsis
  function pageButtons() {
    const btns = [];
    const show = new Set([1, totalPages, page, page - 1, page + 1].filter(p => p >= 1 && p <= totalPages));
    const sorted = [...show].sort((a, b) => a - b);
    sorted.forEach((p, i) => {
      if (i > 0 && p - sorted[i - 1] > 1) {
        btns.push(<span key={`sep-${p}`} className="stu-page-sep">…</span>);
      }
      btns.push(
        <button key={p} className={`stu-page-btn${page === p ? ' stu-page-active' : ''}`} onClick={() => setPage(p)}>{p}</button>
      );
    });
    return btns;
  }

  const totalHours = studentLessons.reduce((s, l) => s + l.duration, 0);

  const lessonsByMonth = {};
  studentLessons.forEach((l) => {
    if (!lessonsByMonth[l.month]) lessonsByMonth[l.month] = [];
    lessonsByMonth[l.month].push(l);
  });

  return (
    <div className="stu-wrap">

        {/* ── LEFT: list ── */}
        <div className="stu-panel">
          <div className="stu-panel-header">
            <div className="stu-panel-title">
              <div className="stu-panel-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </div>
              <div>
                <h2>Alumnos</h2>
                <p>Haz clic en un alumno para ver detalle</p>
              </div>
            </div>
            <span className="stu-count-badge">{filtered.length}</span>
          </div>

          <div className="stu-search-wrap">
            <div className="stu-search-box">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" placeholder="Buscar por nombre o apoderado…" value={query} onChange={handleSearch} />
            </div>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table className="stu-table">
              <thead>
                <tr>
                  <th>Nombre alumno/a</th>
                  <th>Apoderado</th>
                </tr>
              </thead>
              <tbody>
                {pageRows.map((s) => (
                  <tr key={s.id} className={selectedStudent && selectedStudent.id === s.id ? 'stu-selected' : ''} onClick={() => selectStudent(s)}>
                    <td>{s.name}</td>
                    <td className="stu-mother">{s.mother}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="stu-pagination">
            <span className="stu-page-info">
              {filtered.length
                ? `Mostrando ${pageStart + 1}–${Math.min(pageStart + PAGE_SIZE, filtered.length)} de ${filtered.length}`
                : 'Sin resultados'}
            </span>
            <div className="stu-page-btns">
              <button className="stu-page-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>‹</button>
              {pageButtons()}
              <button className="stu-page-btn" disabled={page === totalPages || totalPages === 0} onClick={() => setPage(p => p + 1)}>›</button>
            </div>
          </div>
        </div>

        {/* ── RIGHT: detail ── */}
        <div className="stu-detail">
          {!selectedStudent ? (
            <div className="stu-empty">
              <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.35 }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <p className="stu-empty-title">Ningún alumno seleccionado</p>
              <p className="stu-empty-sub">Haz clic en una fila para ver el detalle</p>
            </div>
          ) : (
            <>
              <div className="stu-detail-header">
                <div>
                  <p className="stu-detail-name">{selectedStudent.name}</p>
                  <p className="stu-detail-sub">Apoderado/a: {selectedStudent.mother}</p>
                </div>
                <a className="stu-edit-btn" href={`/students/${selectedStudent.id}`}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  Editar
                </a>
              </div>

              <div className="stu-chips">
                <div className="stu-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.14 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.05 2.73h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 10.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 18.18z"/></svg>
                  <strong>{selectedStudent.number}</strong>
                </div>
                <div className="stu-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                  <strong>{selectedStudent.school}</strong>
                </div>
                <div className="stu-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <strong>Curso: {selectedStudent.generation}</strong>
                </div>
                <div className="stu-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <strong>{selectedStudent.county}</strong> · {selectedStudent.address}
                </div>
              </div>

              <div className="stu-stats">
                <div className="stu-stat">
                  <div className="stu-stat-value">{studentLessons.length}</div>
                  <div className="stu-stat-label">Clases realizadas</div>
                </div>
                <div className="stu-stat">
                  <div className="stu-stat-value">{totalHours}h</div>
                  <div className="stu-stat-label">Horas totales</div>
                </div>
              </div>

              <div className="stu-lessons">
                {months.map((month) => {
                  const lessons = lessonsByMonth[month];
                  const inactive = inactiveMonths.includes(month);
                  return (
                    <div key={month} className={`stu-month-group${inactive ? ' stu-month-inactive' : ''}`}>
                      <div className="stu-month-label">{month}</div>
                      {inactive ? (
                        <div className="stu-no-classes">Sin clases registradas</div>
                      ) : (
                        lessons.map((lesson, i) => (
                          <div key={i} className="stu-lesson-row">
                            <div className="stu-lesson-dot" />
                            <span className="stu-lesson-date">{lesson.date}</span>
                            <span className="stu-lesson-dur">{lesson.duration}h</span>
                            <span className="stu-lesson-subject">{lesson.lecture}</span>
                          </div>
                        ))
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

      </div>
  );
}

export default hot(module)(Students);
